<template>
    <div class="nr_container_content mt-60 ">

        <v-modal-contents ref="modal_contents_successfully" class="modal_contents_successfully ">
            <template v-slot:close>
                <span></span>
            </template>
            <template v-slot:title>
                <div class="terms_of_use__title">
                    <div class="h2_title h2_title--modal">Ваши ответы приняты</div>
                </div>
            </template>
            <template v-slot:content>
                <div class="terms_of_use">
                    <p class="green_messs">Благодарим вас за уделенное время</p>

                    <a href="/" class="mt-4 btn v-btn btn_poll">Хорошо</a>

                </div>
            </template>
        </v-modal-contents>

        <v-modal-contents ref="modal_alert" class="modal_alert ">
            <template v-slot:title>
                <div class="terms_of_use__title ">
                    <div class="h2_title h2_title--modal">Уведомление</div>
                </div>
            </template>
            <template v-slot:content>
                <div class="terms_of_use ">
                    <p class="green_messs">Пожалуйста, ответьте на все вопросы</p>
                </div>
            </template>
        </v-modal-contents>

        <v-form ref="form" v-model="valid" class="poll" :class="validAll ? 'valid':'noValid'">

            <!-- 1. Данные о компании -->
            <v-text-field class="mb-20"
                          v-model="companyName"
                          label="1. Название Вашей компании"
                          :rules="rulesField"
                          required
            ></v-text-field>

            <!-- 2. Данные о контактном лице -->
            <v-text-field
                    class="mb-20"
                    v-model="contactPerson"
                    label="2. Ваше имя и фамилия"
                    :rules="rulesField"
                    required
            ></v-text-field>

            <!-- 3. Контактные данные -->
            <v-text-field
                    class="mb-20"
                    v-model="email"
                    label="3. Электронная почта"
                    :rules="emailRules"
                    required
                    type="email"
            ></v-text-field>

            <!-- 4. Какие продукты Вы закупаете у ГК «НОВАРОЛЛ»? -->
            <label class="custom_label" :class="purchasedProducts.length === 0 ? 'noValidError':''">
                4. Какие продукты Вы закупаете у ГК NOVAROLL?
            </label>
            <div class="mb-35 checkbox_group">
                <v-checkbox
                        color="red"
                        v-model="purchasedProducts"
                        label="Упаковочные клейкие ленты"
                        value="Упаковочные клейкие ленты"
                ></v-checkbox>
                <v-checkbox
                        color="red"
                        v-model="purchasedProducts"
                        label="Стретч-пленка"
                        value="Стретч-пленка"
                ></v-checkbox>
            </div>

            <!-- 5. Качество продукции (1-10) -->
            <v-radio-group
                    :rules="rulesField"
                    required
                    v-model="productQuality"
                    label="5. Насколько качество продукции ГК NOVAROLL соответствует Вашим ожиданиям? (от 1 до 10, где 1 – качество продукции низкое, 10 – качество продукции полностью соответствует ожиданиям)"
            >
                <v-radio v-for="n in 10" :key="'quality-'+n" color="red" :label="String(n)"
                         :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 6. Вероятность следующего заказа (1-10) -->
            <v-radio-group
                    :rules="rulesField"
                    required
                    v-model="nextOrderProbability"
                    label="6. С какой вероятностью вы разместите следующий заказ? (от 1 до 10, где 1 – пока не стану размещать заказ, 10 – следующий заказ только в ГК NOVAROLL)"
            >
                <v-radio v-for="n in 10" :key="'next-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 7. Удовлетворённость взаимодействием (1-10) -->
            <v-radio-group
                    :rules="rulesField"
                    required
                    v-model="satisfactionLevel"
                    label="7. Оцените, насколько вы в целом удовлетворены взаимодействием с ГК NOVAROLL? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)"
            >
                <v-radio v-for="n in 10" :key="'satisf-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 8. Вероятность рекомендации (1-10) -->
            <v-radio-group
                    :rules="rulesField"
                    required
                    v-model="recommendationProbability"
                    label="8. Оцените, насколько вероятно, что вы порекомендуете ГК NOVAROLL своим коллегам или партнерам? (от 1 до 10, где 1 – не буду рекомендовать, 10 – буду рекомендовать)"
            >
                <v-radio v-for="n in 10" :key="'rec-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 9. Предложения по улучшению (мин. 200 символов) -->
            <v-textarea
                    placeholder="Ваш ответ..."
                    color="red"
                    v-model="improvementSuggestions"
                    label="9. Ваши предложения по улучшению нашей работы/продукции (не менее 10 знаков)"
                    :rules="improvementRules"
                    required
                    rows="1"
                    auto-grow
            ></v-textarea>

            <v-btn class="mt-30" @click.prevent="submitSurvey" color="#f94237">Отправить</v-btn>
        </v-form>

    </div>
</template>

<script>
import VModalContents from "./modal_contents.vue";

export default {
    components: {VModalContents},
    props: {
        r: [String, Number, Boolean],
    },
    data() {
        return {
            valid: false,
            validAll: true,

            // Новые поля
            companyName: "",
            contactPerson: "",
            email: "",
            purchasedProducts: [],
            productQuality: null,
            nextOrderProbability: null,
            satisfactionLevel: null,
            recommendationProbability: null,
            improvementSuggestions: "",

            // Валидация
            rulesField: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => (v && String(v).length >= 1) || "Поле не может быть пустым",
            ],
            emailRules: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => /.+@.+\..+/.test(v) || "Введите корректный email",
            ],
            improvementRules: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => (v && String(v).length >= 10) || "Минимум 10 символов",
            ],
        };
    },
    methods: {
        submitSurvey() {
            if (!this.$refs.form.validate()) {
                this.validAll = false;
                this.$refs.modal_alert.modal_open();
                return;
            }
            if (this.purchasedProducts.length === 0) {
                this.validAll = false;
                this.$refs.modal_alert.modal_open();
                return;
            }
            this.validAll = true;

            const params = new URLSearchParams();
            const surveyData = {
                companyName: this.companyName,
                contactPerson: this.contactPerson,
                email: this.email,
                purchasedProducts: this.purchasedProducts,
                productQuality: this.productQuality,
                nextOrderProbability: this.nextOrderProbability,
                satisfactionLevel: this.satisfactionLevel,
                recommendationProbability: this.recommendationProbability,
                improvementSuggestions: this.improvementSuggestions,
                r: this.r,
            };

            params.set("ajaxPost", "Y");
            params.set("surveyData", JSON.stringify(surveyData));

            const url = "/ajax/polls.php";
            fetch(url, {method: "POST", body: params})
                .then((response) => {
                    console.log("Опрос отправлен:", response);
                    this.$refs.form.reset();
                    this.$refs.modal_contents_successfully.modal_open();
                })
                .catch((error) => {
                    console.error("Ошибка при отправке опроса:", error);
                });
        },
    },
};
</script>

<style class="scss">
.wrapp_multiply {
    margin-top: 38px;
}

h2.modal_alert__title {
    font-size: 20px !important;
}

.poll .error--text {
//margin-bottom: 8px;
}

.poll .v-input.error--text .v-text-field__slot label {
    color: #ff5252 !important;
}

.noValid .noValidError {
    color: #ff5252 !important;
}

</style>

<style scoped>



.poll {
    margin-bottom: 80px;
    .different_el.v-input--is-focused,
    .different_el.v-input--is-label-active {
        margin-top: 18px;
    }


    .checkbox_group {
        .v-text-field.different_el {
            margin-top: 18px;
        }

        .different_el.v-input--is-focused,
        .different_el.v-input--is-label-active {
            margin-top: 25px;
        }
    }

    .v-text-field.different_el {
        padding-top: 0;
    }

    .v-input.error--text .v-input--radio-group__input {
    //border: 1px solid red; width: auto;
    }

    .custom_label {
        font-size: 20px !important;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.6);

        @media (max-width: 500px) {
            font-size: 16px !important;
        }
    }

    label.v-label.theme--light {
        margin-bottom: 0;
    }

    .v-input--checkbox .v-messages.theme--light {
        display: none;
    }

    .v-input--selection-controls.v-input--checkbox {
        margin-top: 4px;
        padding-top: 4px;
    }

    & .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
        color: rgba(0, 0, 0, .87) !important;
    }

    &.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
        margin: 0;

    }

    & .v-input--radio-group legend.v-label {
        font-size: 20px !important;
        font-weight: 600;

        @media (max-width: 500px) {
            font-size: 16px !important;
        }
    }

    & .v-text-field .v-label {
        font-size: 20px !important;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.6) !important;
        display: contents;
        white-space: unset;

        @media (max-width: 500px) {
            white-space: break-spaces;
            font-size: 16px !important;
        }
    }

    & .v-text-field .v-label.v-label--active {
        transform: translateY(-24px) scale(0.75) !important;
        display: block;
        white-space: nowrap;
    }

    & .v-btn {
        color: #FAFAFA;
    }

    & .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
        font-size: 20px !important;
        @media (max-width: 500px) {
            font-size: 16px !important;
        }
    }

    & .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
        display: block;
    }

    & .v-messages__message {
        font-size: 15px !important;
    }
}

.mb-20 {
    margin-bottom: 20px;
}

.btn_poll {
    background: #ff4237;
    text-transform: none;
    padding: 14.5px 34px;
    color: #fff;
    border-radius: 26px;

    font-family: 'RobotoRegular';
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
}
</style>